import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonRow = ({
  width = '100%',
  sectionPadding = false,
  height = 18
}) => {
  return (
    <section className={sectionPadding ? 'section section--sm' : ''}>
      <article className="skeleton-row u--padding-0">
        <Skeleton width={width} height={height} />
      </article>
    </section>
  );
};

export default SkeletonRow;
